/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ambient_Temperature_ValvesInputs */



/**
* | output |
* | --- |
* | "Ambient temperature - Th. head(s)" |
*
* @param {Ambient_Temperature_ValvesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const ambient_temperature_valves = /** @type {((inputs?: Ambient_Temperature_ValvesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ambient_Temperature_ValvesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ambient temperature - Th. head(s)")
	return /** @type {LocalizedString} */ ("Température d'ambiance - Tête(s) th.")
});